let shouldIntercept = false;

export const setPopstateIntercept = (value: boolean) => {
  shouldIntercept = value;
};

export const getShouldInterceptPopstate = () => shouldIntercept;
